import { render } from "./SearchTab.vue?vue&type=template&id=5393365e&scoped=true&ts=true"
import script from "./SearchTab.vue?vue&type=script&lang=ts"
export * from "./SearchTab.vue?vue&type=script&lang=ts"

import "./SearchTab.vue?vue&type=style&index=0&id=5393365e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EugenePrice\\repos\\thinkspatial\\expenses-ionic-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5393365e"]])

export default __exports__